<template>
  <div class="main">
    <el-row>
      <!-- 查询条件 -->
      <el-col class="pagin" ref="query">
        <el-row class="mb5 mt2 ml2">
          <div class="inline-block mr10">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">登录账户:</div>
            <div class="pl4-6 width-200">
              <el-input v-model="formQuery.username" size="small" placeholder="登录账户" clearable></el-input>
            </div>
          </div>
          <div class="inline-block mr10">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">真实姓名:</div>
            <div class="pl4-6 width-200">
              <el-input v-model="formQuery.realname" size="small" placeholder="真实姓名" clearable></el-input>
            </div>
          </div>
          <div class="inline-block mr10">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">状态:</div>
            <div class="pl4-6 width-200">
              <el-select clearable v-model="formQuery.status" placeholder="请选择状态" size="small">
                <el-option v-for="(item, index) in dictStatus" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
              </el-select>
            </div>
          </div>
          <div class="inline-block mr10" v-if="showMore">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">角色:</div>
            <div class="pl4-6 width-200">
              <el-select v-model="formQuery.roleId" filterable placeholder="请选择角色" clearable size="small" class="full" @clear="onSelectClear('roleIdCacheList')" :filter-method="val=>onSelectFilter(val, formQuery, 'roleId', 'roleIdCacheList')">
                  <el-option v-for="(item, index) in roleIdCacheList" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
              </el-select>
            </div>
          </div>
          <div class="inline-block mr10" v-if="showMore&&userInfo.userLevel=='2'">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">关联工厂:</div>
            <div class="pl4-6 width-200">
              <el-select v-model="formQuery.objId" filterable placeholder="请选择关联工厂" clearable size="small" class="full" @clear="onSelectClear('objIdCacheList')" :filter-method="val=>onSelectFilter(val, formQuery, 'objId', 'objIdCacheList')">
                  <el-option v-for="(item, index) in objIdCacheList" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
              </el-select>
            </div>
          </div>
          <div class="inline-block mr10" v-if="showMore">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">创建时间:</div>
            <div class="pl4-6 width-200">
              <el-date-picker
                style="width: 205px;"
                :clearable="true"
                v-model="createTimeDate"
                :picker-options="disabledAfterNow"
                size="small"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </div>
          <div class="inline-block mr4">
            <el-button v-if="checkPermission(funcData, 'query')" size="small" type="primary" icon="el-icon-search" @click="onQuery">查找</el-button>
            <el-button v-if="checkPermission(funcData, 'add')" size="small" type="primary" icon="el-icon-plus" @click="onShowAdd">添加</el-button>
          </div>
          <!-- 批量操作按扭 -->
          <el-dropdown v-if="checkPermission(funcData, 'batchRemove,batchEnable,batchDisable')" size="small" type="primary" trigger="click">
            <el-button type="primary" size="small">
              批量操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="checkPermission(funcData, 'batchRemove')" class="px10" @click.native="onBatchRemove">批量删除</el-dropdown-item>
              <el-dropdown-item v-if="checkPermission(funcData, 'batchEnable')" class="px10" @click.native="onBatchEnable">批量启用</el-dropdown-item>
              <el-dropdown-item v-if="checkPermission(funcData, 'batchDisable')" class="px10" @click.native="onBatchDisable">批量禁用</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-link type="primary" @click="showMore=!showMore" style="margin-left:10px;">{{showMore?'收起∧':'展开∨'}}</el-link>
        </el-row>
      </el-col>

      <!-- 表格  -->
      <el-col v-if="!checkPermission(funcData, 'query')" :style="{height: pageHeight,lineHeight: pageHeight}" class="noPer">没有列表查询权限</el-col>
      <el-col v-else>
        <el-table
          ref="table"
          :key="Math.random()"
          v-loading="pageLoading"
          element-loading-text="拼命加载中"
          size="mini"
          stripe
          border
          style="width: 100%"
          :height="pageHeight"
          :data="dataList"
          :header-cell-class-name="onHeaderClass"
          @sort-change="onSortChange"
          @selection-change="onSelectionChange"
          ><!-- :default-sort = "{prop: 'date', order: 'descending'}" -->

          <el-table-column
            v-if="checkPermission(funcData, 'batchRemove,batchEnable,batchDisable')"
            type="selection"
            width="45"></el-table-column>

          <el-table-column align="center" label="序号" type="index"></el-table-column>

          <el-table-column width="148px" align="center" label="操作">
            <template slot-scope="scope">
              <el-button v-if="checkPermission(funcData, 'detail')" size="mini" title="查看" circle type="success" icon="el-icon-document" @click="onDetail(scope.$index, scope.row)"></el-button>
              <el-button v-if="checkPermission(funcData, 'modify')" size="mini" title="编辑" circle type="warning" icon="el-icon-edit" @click="onShowEdit(scope.$index, scope.row)"></el-button>
              <el-button v-if="checkPermission(funcData, 'remove')" size="mini" title="删除" circle type="danger" icon="el-icon-delete" @click="onPageRemove(scope.$index, scope.row)"></el-button>
              <el-button v-if="checkPermission(funcData, 'resetPwd')" size="mini" title="重置密码" circle type="primary" icon="el-icon-key" @click="onShowPwd(scope.$index, scope.row)"></el-button>
            </template>
          </el-table-column>

          <el-table-column
            show-overflow-tooltip
            prop="roleId"
            label="角色"
            sortable="custom"
            >
            <template slot-scope="scope">
              {{scope.row.roleId|dict(roleIdCacheListCopy)}}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="username"
            label="登录账户"
            sortable="custom"
            >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="realname"
            label="真实姓名"
            sortable="custom"
            >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="objId"
            label="关联工厂"
            sortable="custom"
            v-if="userInfo.userLevel=='2'"
            >
            <template slot-scope="scope">
              {{scope.row.objId|dict(objIdCacheListCopy)}}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="status"
            label="状态"
            sortable="custom"
            >
            <template slot-scope="scope">
              <el-switch
                v-if="checkPermission(funcData, 'enable,disable')"
                :disabled="((scope.row.status!='1' && !checkPermission(funcData, 'enable')) || (scope.row.status=='1' && !checkPermission(funcData, 'disable')))"
                style="margin-right: 5px;"
                @change="onSwitch(scope.$index, scope.row)"
                v-model="scope.row.switch"
                active-color="#409eff"
                inactive-color="#dcdfe6">
              </el-switch>
              <el-tag size="small" type="success" v-if="scope.row.status == '1'">{{scope.row.status|dict(dictStatus)}}</el-tag>
              <el-tag size="small" type="danger" v-else>{{scope.row.status|dict(dictStatus)}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="createTime"
            label="创建时间"
            sortable="custom"
            >
          </el-table-column>
        </el-table>
      </el-col>

      <!-- 分页 -->
      <el-col class="pagination">
        <el-pagination
          background
          :current-page="pageParam.pageNo"
          :page-sizes="[30, 50, 100, 200, 500, 1000]"
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          layout="prev, pager, next, total, jumper, sizes"
          :total="pageTotal">
        </el-pagination>
      </el-col>
    </el-row>

    <!-- 详情弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogDetail" width="700px" top="8vh">
      <template slot="title"><i class="el-icon-document" /> 工厂用户详情</template>
      <el-descriptions class="detail-div" :column="2" size="small" border labelClassName="detail-label" contentClassName="detail-content">
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-s-custom"></i>登录ID</template>
          {{dataDetail.userId}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-user"></i>角色</template>
          {{dataDetail.roleId|dict(roleIdCacheListCopy)}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-bank-card"></i>登录账户</template>
          {{dataDetail.username}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-user-solid"></i>真实姓名</template>
          {{dataDetail.realname}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-s-opportunity"></i>关联工厂</template>
          {{dataDetail.objId|dict(objIdCacheListCopy)}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-open"></i>状态</template>
          {{dataDetail.status|dict(dictStatus)}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-time"></i>创建时间</template>
          {{dataDetail.createTime}}
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogDetail=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 添加弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogAdd" width="480px" @closed="onResetForm('formAdd')" top="8vh">
      <template slot="title"><i class="el-icon-document-add" /> 添加工厂用户</template>
      <el-form :model="formAdd" ref="formAdd" :rules="formAddRules" size="small" inline label-width="100px">
        <el-form-item label="角色" prop="roleId">
          <el-select class="width-1" v-model="formAdd.roleId" filterable placeholder="请选择角色" clearable size="small" @clear="onSelectClear('roleIdCacheList')" :filter-method="val=>onSelectFilter(val, formAdd, 'roleId', 'roleIdCacheList')">
            <el-option v-for="(item, index) in roleIdCacheList" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="登录账户" prop="username">
          <el-input class="width-1" v-model="formAdd.username" placeholder="请输入登录账户" maxlength="32" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="userpwd">
          <el-input class="width-1" v-model="formAdd.userpwd" placeholder="请输入登录密码" maxlength="64" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="realname">
          <el-input class="width-1" v-model="formAdd.realname" placeholder="请输入真实姓名" maxlength="60" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="关联工厂" prop="objId" v-if="userInfo.userLevel=='2'">
          <el-select class="width-1" v-model="formAdd.objId" filterable placeholder="请选择关联工厂" clearable size="small" @clear="onSelectClear('objIdCacheList')" :filter-method="val=>onSelectFilter(val, formAdd, 'objId', 'objIdCacheList')">
            <el-option v-for="(item, index) in objIdCacheList" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="仓库关联模式" prop="subType">
          <el-radio-group class="width-1" v-model="formAdd.subType">
            <el-radio label="0">排除</el-radio>
            <el-radio label="1">包含</el-radio>
          </el-radio-group>
          <el-tooltip class="item" effect="dark" placement="bottom-start">
            <div slot="content">排除模式：不能访问和操作排除的仓库<br/>包含模式：只能访问和操作包含的仓库</div>
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="关联仓库列表" prop="subLists">
          <el-select class="width-1" v-model="formAdd.subLists" multiple filterable placeholder="请选择仓库" clearable size="small" @clear="onSelectClear('userStoreIdCacheList')" :filter-method="val=>onSelectFilter(val, formAdd, 'userStoreId', 'userStoreIdCacheList')">
            <el-option v-for="(item, index) in userStoreIdCacheList" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
          </el-select>
          <el-tooltip class="item" effect="dark" content="列表为空默认不生效" placement="bottom-start">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmitAdd()" size="small">提 交</el-button>
        <el-button @click="dialogAdd=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 编辑弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogModify" width="480px" @closed="onResetForm('formEdit')" top="8vh">
      <template slot="title"><i class="el-icon-edit" /> 编辑工厂用户</template>
      <el-form :model="formEdit" ref="formEdit" :rules="formEditRules" size="small" inline label-width="100px">
        <el-form-item label="登录账户" prop="username">
          <el-input class="width-1" v-model="formEdit.username" placeholder="请输入登录账户" maxlength="32" show-word-limit disabled clearable></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="realname">
          <el-input class="width-1" v-model="formEdit.realname" placeholder="请输入真实姓名" maxlength="60" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="仓库关联模式" prop="subType">
          <el-radio-group class="width-1" v-model="formEdit.subType">
            <el-radio label="0">排除</el-radio>
            <el-radio label="1">包含</el-radio>
          </el-radio-group>
          <el-tooltip class="item" effect="dark" placement="bottom-start">
            <div slot="content">排除模式：不能访问和操作排除的仓库<br/>包含模式：只能访问和操作包含的仓库</div>
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="关联仓库列表" prop="subLists">
          <el-select class="width-1" v-model="formEdit.subLists" multiple filterable placeholder="请选择仓库" clearable size="small" @clear="onSelectClear('userStoreIdCacheList')" :filter-method="val=>onSelectFilter(val, formEdit, 'userStoreId', 'userStoreIdCacheList')">
            <el-option v-for="(item, index) in userStoreIdCacheList" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
          </el-select>
          <el-tooltip class="item" effect="dark" content="列表为空默认不生效" placement="bottom-start">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmitEdit()" size="small">提 交</el-button>
        <el-button @click="onResetEdit" size="small">重 置</el-button>
      </div>
    </el-dialog>

    <!-- 重置密码弹窗 -->
    <el-dialog :close-on-click-modal="false" title="重置密码" :visible.sync="dialogResetPwd" width="460px" @closed="onResetForm('resetPwdForm');">
      <el-form :model="resetPwdForm" ref="resetPwdForm" :rules="resetPwdFormRules" size="mini" label-width="80px">
<!--        <el-form-item label="登录密码" prop="loginPwd">-->
<!--          <el-input type="password" class="width-300" style="width:288px;" v-model="resetPwdForm.loginPwd" placeholder="请输入当前登录用户的密码" maxlength="32" show-word-limit clearable></el-input>-->
<!--        </el-form-item>-->

        <el-form-item label="新密码" prop="userPwd">
          <el-input class="width-300" style="width:288px;" v-model="resetPwdForm.userPwd" placeholder="请输入新密码" maxlength="32" show-word-limit clearable></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type='primary' @click="onSubmitPwd()" size="small">提 交</el-button>
        <el-button @click="dialogResetPwd=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import validator from '@/utils/validator' // 引入检查器
import axios from 'axios' // 引入页面处理
import rsa from '@/utils/rsa'

export default {
  name: 'userplatProdFactorylogin',
  data () {
    return {
      menuName: 'userplatProdFactorylogin',
      dialogResetPwd: false, // 修改密码对话框
      formQuery: { // 查询对象
        username: '', // 登录账户
        realname: '', // 真实姓名
        status: '', // 状态
        roleId: '', // 角色
        objId: '', // 关联工厂
        createTimeBegin: '', // 创建时间-开始时间
        createTimeEnd: '' // 创建时间-结束时间
      },
      formAdd: { // 新增对象
        roleId: '', // 角色
        username: '', // 登录账户
        userpwd: '', // 登录密码
        realname: '', // 真实姓名
        objId: '', // 关联工厂
        subType: '0', // 仓库关联模式
        subList: [] // 关联仓库列表
      },
      resetPwdForm: { // 重置密码
        loginPwd: '1',
        userId: '',
        userPwd: ''
      },
      resetPwdFormRules: {
        // loginPwd: [{ required: true, message: '请输入登录密码', trigger: 'blur' }],
        userPwd: [{ required: true, message: '请输入新密码', trigger: 'blur' }]
      },
      formAddRules: { // 新增规则
        roleId: [{ required: true, message: '请输入角色', trigger: 'blur' }],
        username: [{ required: true, message: '请输入登录账户', trigger: 'blur' }, { validator: validator.letterDigital, trigger: 'blur' }],
        userpwd: [{ required: true, message: '请输入登录密码', trigger: 'blur' }, { validator: validator.letterDigitalSymbol, trigger: 'blur' }],
        objId: [{ required: true, message: '请输入关联工厂', trigger: 'blur' }]
      },
      formEditRules: { // 更新规则
        username: [{ required: true, message: '请输入登录账户', trigger: 'blur' }, { validator: validator.letterDigital, trigger: 'blur' }]
      },
      dictStatus: [], // 状态
      roleIdCacheList: [],
      roleIdCacheListCopy: [],
      objIdCacheList: [],
      objIdCacheListCopy: [],
      userStoreIdCacheList: [],
      userStoreIdCacheListCopy: [],
      idName: 'userId',
      httpUrl: '/prod/factoryLogin',
      httpUri: {
        roleIdCacheUri: '/cache/role',
        objIdCacheUri: '/cache/userFactory',
        userStoreIdCacheUri: '/cache/userStore'
      },
      userInfo: {}
    }
  },
  watch: {
    $route (to, from) {
      if (this.menuName != to.name) { // 切走不处理
        return
      }
      let query = to.query
      if (query.objId) {
        this.formQuery.objId = query.objId
        this.formAdd.objId = query.objId
      }
      this.httpQuery()
    },
    'formAdd.objId': {
      handler (curVal, oldVal) {
        this.httpSelectList('userStoreIdCacheList', this.httpUri.userStoreIdCacheUri, { userFactId: curVal })
      },
      deep: true
    },
    'formEdit.objId': {
      handler (curVal, oldVal) {
        this.httpSelectList('userStoreIdCacheList', this.httpUri.userStoreIdCacheUri, { userFactId: curVal })
      },
      deep: true
    }
  },
  mounted () {
    let query = this.$route.query
    if (query.objId) {
      this.formQuery.objId = query.objId
      this.formAdd.objId = query.objId
      this.httpQuery()
    }
    this.getSysDict('STATUS_TYPE', 'dictStatus', 'getStatus')
    this.httpSelectList('roleIdCacheList', this.httpUri.roleIdCacheUri, { platId: 'userplat', userLevel: 3 })
    this.httpSelectList('objIdCacheList', this.httpUri.objIdCacheUri)
  },
  methods: {
    onShowPwd (index, row) {
      this.resetPwdForm.userId = row.userId
      this.dialogResetPwd = true
    },
    onSubmitPwd () {
      this.$refs.resetPwdForm.validate((valid) => {
        if (valid) {
          axios({
            url: this.pageUrl + '/resetPwd',
            method: 'post',
            data: {
              userId: this.resetPwdForm.userId,
              loginPwd: rsa.rsaPublicData(this.resetPwdForm.loginPwd),
              userPwd: rsa.rsaPublicData(this.resetPwdForm.userPwd)
            }
          }).then(res => {
            if (res.data.code === '0000') {
              this.dialogResetPwd = false
              this.$message.success(res.data.message)
            }
          }).catch(err => console.log(err, 'onSubmitPwd'))
        } else {
          // console.log('error http!!')
          return false
        }
      })
    },
    removeTip (row) {
      let factName = this.mapSelect(this.objIdCacheListCopy, 'codeId', row.objId, 'codeName')
      return `工厂名称：${factName}<br/>登录账号：${row.username}<br/>确认要删除该工厂用户？`
    }
  }
}
</script>

<style scoped>
@import "../../assets/page.css";

</style>
